import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IDining } from "../diningModal";

export const getAllDining = createAsyncThunk(
  "Dining/FindAllDining",
  async (filters: { DiningTitle: string }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dining/FindAllDining`,
        filters,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Dining:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createDining = createAsyncThunk(
  "Dining/InsertDining",
  async (DiningData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dining/InsertDining`,
        DiningData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Dining:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateDining = createAsyncThunk(
  "Dining/UpdateDining",
  async (DiningData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dining/UpdateDining`,
        DiningData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Dining:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteDining = createAsyncThunk(
  "Dining/DeleteDining",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dining/DeleteDining`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Dining :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getDiningByID = createAsyncThunk(
  "Dining/FindByIDDining",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dining/FindByIDDining`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ...result,
        IsActive: result.IsActive ? 1 : 2,
      } as IDining;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Dining :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveDining = createAsyncThunk(
  "Dining/FindAllActiveDining",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dining/FindAllActiveDining`,
        {},
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Dining:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveDining = createAsyncThunk(
  "Dining/ActiveInActiveDining",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dining/ActiveInActiveDining`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Dining :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const DiningImageUpload = createAsyncThunk(
  "Dining/DiningImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dining/DiningImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Dining Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteDiningImage = createAsyncThunk(
  "Dining/DeleteDiningGalleryImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dining/DeleteDiningGalleryImage`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Dining Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
